















































































































































































































































































































































































































































































































































































































import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  ref,
} from '@vue/composition-api';
import Pagination from '@/components/Pagination';
import Box from '@/components/Box';
import DialogCom from '@/components/Dialog/index';
import Steps from '@/components/Steps/index';
import request from '@/utils/request';
import addComma from '@/utils/addComma';
import { Message } from 'element-ui';
import svgCom from '@components/Svg/index';
import _Const from '@/Const';
import { floatObj } from '@/utils/tools';
// import { stat } from 'fs';

export default defineComponent({
  name: 'editTwo',
  components: {
    svgCom,
    Box,
    Pagination,
    DialogCom,
    Steps,
  },
  setup(props: any, { root }) {
    // const isSpecialOffer =
    //   new Date() <= new Date(2025, 0, 1) &&
    //   new Date() >= new Date(2024, 10, 15);
    // const isSpecialOfferByCMB =
    //   new Date() <= new Date(2025, 0, 1) && new Date() >= new Date(2024, 11, 1);
    // const isSpecialOfferBySPD =
    //   new Date() <= new Date(2025, 0, 1) && new Date() >= new Date(2024, 11, 5);
    const isSpecialOffer = false;
    const isSpecialOfferByCMB = false;
    const isSpecialOfferBySPD = false;
    const readyBank = _Const.ReadyBankCode;
    const uploadDemo = ref(null);
    const bankCode = ref('');
    const dialogBankVisible = ref(false);
    const ismul = ref(true);
    const dialogVisible = ref(false);
    const dialogMsg = ref('');
    // const codeToImg = ref({
    //   // eslint-disable-next-line @typescript-eslint/no-require-imports
    //   CMB: require('../../../../assets/images/icon/bank_zhaoshang.png'),
    //   // eslint-disable-next-line @typescript-eslint/no-require-imports
    //   CCB: require('../../../../assets/images/icon/bank_jianshe.png'),
    //   // eslint-disable-next-line @typescript-eslint/no-require-imports
    //   PINGAN: require('../../../../assets/images/icon/bank_pinan.png')
    // });
    const state: any = reactive({
      fullBankList: ['CCB', 'SPD', 'BOC', 'PINGAN', 'ICBC'],
      form: {
        applyAmount: null,
        applyDays: null,
        bankCode: null,
      },
      calculateForm: {
        one: null,
        two: null,
        three: null,
        four: null,
        five: null,
      },
      attrConfig: {
        column: [
          { key: 'custom', label: '序号', custom: true, width: 50 },
          { key: 'fileName', label: '附件名称' },
          { key: 'fileSize', label: '附件大小', custom: true },
          { key: 'uploadTime', label: '上传日期' },
          { key: 'createBy', label: '上传人' },
          { key: 'operate', label: '操作', operate: true },
        ],
        data: [],
      },
      calculator: false,
      tableConfig: {
        column: [
          {
            key: 'custom',
            label: '序号',
            custom: true,
            align: 'center',
            width: 50,
          },
          { key: 'payCorpName', label: '付款企业名称' },
          { key: 'supplierName', label: '供应商名称' },
          { key: 'orderNo', label: '付款单号', width: 210 },
          {
            key: 'amount',
            label: '付款金额',
            width: 130,
            custom: true,
            align: 'right',
            headerAlign: 'right',
          },
          { key: 'currency', label: '币种', width: 70 },
          { key: 'orderTypeName', label: '付款单类型' },
          { key: 'orderStatusName', label: '付款单状态', width: 110 },
          { key: 'planPayTime', label: '预计付款日期', width: 110 },
        ],
        data: [],
      },
      fileList: [],
      formData: new FormData(),
      bankList: [],
      bankListSigned: [],
      bankListUnsigned: [],
      supplierId: '',
      financeOrderApply: [],
      financeOrderFile: [],
      financeOrderComment: [],
    });
    const getDetail = async () => {
      const { referenceId } = root.$route.query;
      const referenceIdArr = typeof referenceId === 'string' && [
        ...referenceId.split(','),
      ];
      const financeOrderApplyIdArr =
        typeof root.$route.query.financeOrderApplyId === 'string' &&
        root.$route.query.financeOrderApplyId.split(',');
      if (referenceId) {
        const result = await request('financing', 'financingUndoDetail', {
          referenceId: referenceIdArr,
        });
        if (result.code === 2000) {
          state.tableConfig.data = result.data;
          state.form.amount = result.data
            .map((row) => row.amount)
            .reduce((a, b) => floatObj().add(a, b), 0);
          state.form.applyDays =
            result.data.map((row) => row.financingDays)[0] || '';
          state.supplierId = result.data.map((row) => row.supplierId)[0] || '';
        }
      } else {
        const result = await request('financing', 'financingDetail', {
          financeOrderApplyId: financeOrderApplyIdArr,
        });
        const financeOrderUndo = result.data.map((row) => row.financeOrderUndo);
        const financeOrderApply = result.data.map(
          (row) => row.financeOrderApply,
        );
        if (result.code === 2000) {
          state.tableConfig.data = financeOrderUndo;
          state.form = {
            bankCode: financeOrderApply[0].bankCode,
            bankName: financeOrderApply[0].bankName,
            applyAmount: financeOrderApply[0].applyAmount,
            applyDays: financeOrderApply[0].applyDays,
            // comment: financeOrderComment?.comment,
            amount: financeOrderUndo
              .map((row) => row.amount)
              .reduce((a, b) => floatObj().add(a, b), 0),
          };
          state.supplierId = financeOrderApply[0].supplierId || '';
          state.financeOrderApply = financeOrderApply;
        }
      }
      if (
        (referenceIdArr && referenceIdArr.length > 1) ||
        (financeOrderApplyIdArr && financeOrderApplyIdArr.length > 1)
      ) {
        ismul.value = true;
        state.form.applyAmount = state.form.amount;
      } else {
        ismul.value = false;
      }
      const result = await request('financing', 'bankList', {
        supplierId: state.supplierId,
      });
      if (result.code === 2000) {
        state.bankList = result.data;
        state.bankListSigned = [];
        state.bankListUnsigned = [];
        result.data.forEach((item) => {
          item.isSigned === 'Y'
            ? state.bankListSigned.push(item)
            : state.bankListUnsigned.push(item);
        });
      }
    };
    const submit = async (type) => {
      if (!state.form.applyAmount || state.form.applyAmount <= 0) {
        Message.error('融资金额不能为空并且不能小于等于零');
        return;
      }
      if (!state.form.applyDays || state.form.applyDays <= 0) {
        Message.error('融资天数不能为空并且不能小于等于零');
        return;
      }
      if (!state.form.bankCode) {
        Message.error('融资银行不能为空');
        return;
      }
      const params = state.tableConfig.data.map((row, index) => {
        return {
          ...row,
          ...state.financeOrderApply[index],
          ...state.form,
          applyAmount:
            state.tableConfig.data.length > 1
              ? row.amount
              : state.form.applyAmount,
          amount: row.amount,
          applyDays: root.$route.query.referenceId
            ? row.financingDays
            : state.financeOrderApply[index].applyDays,
          bankName: (
            state.bankList.find(
              (item: any) => item.bankCode === state.form.bankCode,
            ) as any
          ).bankName,
          applyStatus: 0,
          buttonType: 'save',
          saveFileIds: state.attrConfig.data.map(
            (item) => item.financeOrderFileId,
          ),
        };
      });

      const res = await request('financing', 'checkBank', params);
      if (res.code === 7062) {
        dialogMsg.value = `${res.message}`;
        dialogVisible.value = true;
      }
      if (res.code === 2000) {
        const result = await request('financing', 'financingSave', params);
        if (result.code === 2000) {
          if (type === 'save') Message.success('保存成功');
          root.$router.push({
            path:
              type === 'save'
                ? '/financing/search'
                : `/financing/edit/editThree/${result.data.join(',')}`,
          });
        }
      }
    };
    const goBack = () => {
      root.$router.push({
        path: '/Financing/edit/editOne',
      });
    };
    // 计算器
    const closeDialog = () => {
      state.calculator = false;
    };
    const openCalculator = () => {
      state.calculator = true;
    };
    const calculate = () => {
      const { one, two, three } = state.calculateForm;
      const four = Number(
        (((Number(one) * (Number(two) / 100)) / 360) * Number(three)).toFixed(
          2,
        ),
      );
      state.calculateForm.four = four;
      state.calculateForm.five = floatObj().subtract(one, four);
    };
    const resetForm = () => {
      state.calculateForm = {
        one: null,
        two: null,
        three: null,
        four: null,
        five: null,
      };
    };
    // 计算器

    // 上传
    const uploadFile = async (file) => {
      if (file.file.size > 5 * 1024 * 1024) {
        Message.warning('附件大小不能大于5M');
        state.fileList = [];
        state.fileTotal = 0;
        return;
      }
      state.formData.append('files', file.file);
      if (state.formData.getAll('files').length !== state.fileTotal) return;
      const result = await request(
        'financing',
        'financingFileUpload',
        state.formData,
      );
      if (result?.code === 2000) {
        state.attrConfig.data = [...state.attrConfig.data, ...result.data];
      } else {
        Message.error('上传失败');
      }
      state.fileList = [];
      state.fileTotal = 0;
    };
    const handChange = (file) => {
      if (file.status === 'ready') state.fileList.push(file.raw);
      const fileTotal: any = (
        document.getElementsByName('upload-demo')[0] as any
      ).files.length;
      if (fileTotal > 0) state.fileTotal = fileTotal;
      state.formData = new FormData();
      if (state.fileList.length === state.fileTotal) {
        (uploadDemo.value as any).submit();
      }
    };
    // 上传

    // 删除附件
    const removeFlie = async (row) => {
      const parms = {
        financeOrderFileId: row.financeOrderFileId,
      };
      const result = await request('financing', 'financingFileDelete', parms);
      if (result.code === 2000) {
        state.attrConfig.data = state.attrConfig.data.filter(
          (item) => item.financeOrderFileId !== row.financeOrderFileId,
        );
      }
    };

    // 下载附件
    const downFile = async (row) => {
      const parms = {
        financeOrderFileId: row.financeOrderFileId,
      };
      await request('financing', 'financingFileDownload', parms);
    };

    // 计算融资天数
    const calApplyDays = (planPayTime) => {
      const timeNow = new Date().getTime();
      const timePay = new Date(planPayTime).getTime();
      return Math.floor(Math.abs(timePay - timeNow) / (24 * 60 * 60 * 1000));
    };

    const toGuide = () => {
      dialogBankVisible.value = false;
      let path = '';
      if (bankCode.value === 'CMB') {
        path = 'https://sme.cmbchina.com/supply-project-detail?project=tencent';
      } else if (bankCode.value === 'CCB') {
        path = 'https://www.ccbscf.com/credit/tx.html';
      } else if (bankCode.value === 'SPD') {
        path =
          'https://ebank.spdb.com.cn/msent-web-pubinternet/PreTencentFactoring.do';
      } else if (bankCode.value === 'BOC') {
        path = 'https://sz.brcloud.bankofchina.com/jtzy/wx/rydProduce/index.html';
      } else if (bankCode.value === 'PINGAN') {
        path =
          'https://b.pingan.com.cn/kuaizhan/stb/5K1477/20231020/k84894/index.html';
      } else if (bankCode.value === 'ICBC') {
        path = 'https://www.sz.icbc.com.cn/szdgz/txdzbl/txdzbl.html';
      }
      window.open(path, '_blank');
    };

    const toggleBankCode = (bankCode) => {
      if (state.fullBankList.includes(bankCode)) {
        state.form.applyAmount = state.form.amount;
      }
    };

    onMounted(() => {
      getDetail();
    });

    return {
      ...toRefs(state),
      closeDialog,
      openCalculator,
      calculate,
      resetForm,
      goBack,
      submit,
      uploadFile,
      handChange,
      removeFlie,
      downFile,
      calApplyDays,
      uploadDemo,
      // codeToImg,
      toGuide,
      addComma,
      bankCode,
      dialogBankVisible,
      ismul,
      dialogMsg,
      dialogVisible,
      toggleBankCode,
      readyBank,
      isSpecialOffer,
      isSpecialOfferByCMB,
      isSpecialOfferBySPD,
    };
  },
});
